import { Skeleton } from 'antd';
import React from 'react';

import './style.scss';

interface propsInterface {
  title?: string;
  subtitle?: string;
  image?: string | undefined;
  options?: React.ReactNode;
}

const Summary = (
  {
    title,
    subtitle,
    image,
    options
  }: propsInterface
) => {
  return (
    <div className='v-summary'>
      <div className='o-img-box'>
        {
          image ?
            <img src={image} alt={title} /> :
            <Skeleton.Image />
        }
      </div>

      <div className='o-details-box'>
        <h4>{title}</h4>
        <h5>{subtitle}</h5>

        <div className='o-options'>
          {options}
        </div>
      </div>
    </div>
  );
}

export default Summary;
